import React from "react"
import styled from "styled-components"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {H2, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {TextButton} from "@irati/ui/src/Button"

const StyledTextButton = styled(TextButton)`
  text-decoration: underline;
`

interface Props extends RouteComponentProps<{checkoutId: string}> {
  onRetry: () => any
}

const UnknownError: React.FC<Props> = (props) => {
  const retry = (
    <StyledTextButton onClick={props.onRetry}>
      <FormattedMessage id="perks.components.unknownRedemptionError.retryText" />
    </StyledTextButton>
  )

  return (
    <div>
      <H2 marginBottom>
        <FormattedMessage id="platform.oops.header.text" />
      </H2>
      <Body marginBottom={2}>
        <FormattedMessage id="perks.components.unknownRedemptionError.errorText" values={{retry}} />
      </Body>
    </div>
  )
}

export default withRouter(UnknownError)
